import { internationalBankFieldCategory, } from '../models';
export const isInternationalFieldCategoryBank = (field) => field.category === internationalBankFieldCategory.Enum.bank;
export const isInternationalFieldCategoryBeneficiary = (field) => field.category === internationalBankFieldCategory.Enum.beneficiary;
export const isInternationalFieldCategoryBankExtra = (field) => field.category === internationalBankFieldCategory.Enum.bank_extra;
export const mapFieldToByFieldNameTuple = (field) => [field.field, field];
export const getFieldsFromEntries = (entries) => Object.fromEntries(entries);
